import { put, takeLatest } from 'redux-saga/effects'
import {
  revokeMfaMechanismSucceeded,
  revokeMfaMechanismFailed
} from '../../actions/mfaSettings'
import { revokeMFAMechanism as submit } from '../api/revokeMFAMechanism'
import {
  REVOKE_MFA_MECHANISM,
  REVOKE_ALL_MFA_MECHANISMS
} from '../../constants/action.types'
import { RECOVERY_OTP } from '../../constants/mfa'
import executeSaga from './helpers/executeSaga'

export function* revokeMFAMechanism({ request }, action) {
  const { mfaMechanism, password, recaptchaResponse } = action.payload || {}
  const data = {
    mfaMechanism: mfaMechanism || RECOVERY_OTP,
    password: password,
    recaptchaResponse: recaptchaResponse
  }

  yield executeSaga(
    request,
    data,
    () =>
      put(
        revokeMfaMechanismSucceeded({
          mfaMechanism: mfaMechanism || RECOVERY_OTP
        })
      ),
    error => put(revokeMfaMechanismFailed({ errorCode: error.message }))
  )
}

export default function*({ request } = { request: submit }) {
  yield takeLatest(
    [REVOKE_ALL_MFA_MECHANISMS, REVOKE_MFA_MECHANISM],
    revokeMFAMechanism,
    { request }
  )
}
